module.exports = __webpack_public_path__ + "media/Tools.ae44a25301c10711979f3a10dee32124.svg";